import SyncableModel from './SyncableModel';
import Farm from './Farm';
import { getRootStore } from "../utils/root-store"

export default class FarmParameter extends SyncableModel {
    static name = 'FarmParameter'

    _table = 'farm_parameter'

    _fillable = [
      'id', 'farm_id', 'parameter_id',
      'lowest_limit', 'low_limit',
      'high_limit', 'highest_limit',
      'hidden',
      'created_at', 'updated_at', 'deleted_at', 'synced_at',
    ]

    _casts = {
      hidden: 'boolean'
    }

    static _parents = ['farm'];

    static endpoint = '/farm_parameters'

    relationFarm() {
      return Farm.query().withoutGlobalScope('soft_delete').whereKey(this.farm_id);
    }

    static async syncAll(
      params = {}, sqlParams = [], cleanAfterSync = true,
      onSyncProgressUpdate = undefined, onError = undefined
    ) {
      const { userStore: { user } } = getRootStore();
      const _params = { ...params };
      const _sqlParams = [...sqlParams];
      if (user && user.role_id === 1 && !_params.farm_id__in) {
        _params.has = 'farm.farm_user';
      }
      return super.syncAll(_params, _sqlParams, cleanAfterSync, onSyncProgressUpdate, onError);
    }
}
